module.exports = __webpack_public_path__ + "img/trafficlight.cfda11df.svg";